import { render, staticRenderFns } from "./MSOSupplierBase.vue?vue&type=template&id=e1c251d4&"
import script from "./MSOSupplierBase.vue?vue&type=script&lang=js&"
export * from "./MSOSupplierBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports